/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".w-text-area[_ngcontent-%COMP%]{height:65px}.slider-text[_ngcontent-%COMP%]{text-align:left;margin-left:calc(5% + 20px);font-size:14px;font-weight:300;margin-bottom:-5px}  .mat-slider-horizontal{width:90%}"];
export { styles as styles };
